module.exports = __webpack_public_path__ + "static/media/i.7cca9f06.svg";